
  module.exports = {
    // 开发环境
    dev: {
      base  : '/url',
    },
    // 生产环境
    pro: {
      base  : 'https://apimanager.wecloudx.com',  //正式环境
      // base  : 'https://api-wy-data-manager-test.wecloudx.com',  //测试环境
    },
    test: {
      // base  : 'https://apimanager.wecloudx.com',  //正式环境
      base  : 'https://api-wy-data-manager-test.wecloudx.com',  //测试环境
    }
  }
 


//////////////////
// WEBPACK FOOTER
// ./ui-domain/api.js
// module id = 9xHj
// module chunks = 101